<template>
  <div class="homeContainer">
    <!-- <div class="goTop" @click="scrollToTop"> 

		</div> -->
    <full-page :options="options" ref="fullpage">
      <div class="section pageBox1">
        <!-- 导航 -->
        <div class="navBar">
          <img class="navLogo" src="../assets/logo.png" alt="" />
          <ul class="navBarItem">
            <!-- <li class="busiz-active-sel">
              <router-link exact to="/" tag="a">首页</router-link>
            </li> -->
            <li>
              <router-link to="/aboutlanshu" exact tag="a"
                >关于兰树</router-link
              >
            </li>
            <el-dropdown>
              <li>
                <router-link to="/huaiBrand" exact tag="a"
                  >兰树品牌</router-link
                >
              </li>
              <el-dropdown-menu class="elDropdown" slot="dropdown">
                <el-dropdown-item
                  ><li @click="chooseBrand(1)">
                    <router-link to="/huaiBrand" tag="a">淮树</router-link>
                  </li></el-dropdown-item
                >
                <el-dropdown-item
                  ><li @click="chooseBrand(2)">
                    <router-link to="/brand" tag="a">心清堂</router-link>
                  </li></el-dropdown-item
                >
                <el-dropdown-item
                  ><li @click="chooseBrand(3)">
                    <router-link to="/shuiBrand" tag="a">水姻缘</router-link>
                  </li></el-dropdown-item
                >
                <el-dropdown-item
                  ><li @click="chooseBrand(4)">
                    <router-link to="/yiBrand" tag="a">一清堂</router-link>
                  </li></el-dropdown-item
                >
                <el-dropdown-item
                  ><li @click="chooseBrand(5)">
                    <router-link to="/zhongBrand" tag="a"
                      >Dr.CHUNG<span style="vertical-align: super;"
                        >+</span
                      ></router-link
                    >
                  </li></el-dropdown-item
                >
                <el-dropdown-item
                  ><li @click="chooseBrand(6)">
                    <router-link to="/lanshuBrand" tag="a">兰树</router-link>
                  </li></el-dropdown-item
                >
                <el-dropdown-item
                  ><li @click="chooseBrand(7)">
                    <router-link to="/zbqfBrand" tag="a">植本清方</router-link>
                  </li></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <li>
              <router-link to="/park" exact tag="a">智慧园区</router-link>
            </li>
            <li>
              <router-link to="/brandLanshu" exact tag="a"
                >美业菩提</router-link
              >
            </li>
            <li>
              <router-link to="/school" exact tag="a">兰树商学院</router-link>
            </li>
            
            <li>
              <router-link to="/dynamicLanshu" exact tag="a"
                >菩提基金会</router-link
              >
            </li>
            
            <li>
              <router-link to="/lanshuTrends" exact tag="a"
                >兰树动态</router-link
              >
            </li>
          </ul>
        </div>
        <!-- 视频组件开始 -->
        <div class="busiz-mengban">
          <div
            class="login-container"
            v-show="isVideo"
            v-html="videoDetails"
          ></div>
        </div>
      </div>
      <!-- <div class="section pageBox2">
        <div class="pageBoxMiddle">
          <div class="mainContent">
            <div class="aboutUsBox">
              <span>走进兰树</span>
              <div class="introduce">LASUR INTRO</div>
            </div>
            <div class="contentLine"></div>
            <div class="mainContentLeftBox">
              <div class="mainContentLeft">
                兰树化妆品股份有限公司（以下简称公司或兰树）是一家集研发、生产、销售、服务为一体的化妆品公司，旗下拥有“淮树”、“一清堂”、“心清堂”和“水姻缘”四大品牌（以下合称“兰树品牌”）。“兰树品牌”创立至今，一直秉持“取自然之本，集万物精粹”的养肤理念，传承东方养肤智慧，融合现代尖端科学技术，致力于打造更适合东方肌肤的化妆品。
              </div>
              <div class="seeMore" @click="enterAboutUs()">
                <img src="../assets/newLasur/logo.png" alt="" />
                <span>了解更多兰树信息</span>
              </div>
            </div>
            <div class="leftBottom">
              <img src="../assets/newLasur/leftBottom.png" alt="" />
            </div>
            <img
              class="mainContentRight"
              src="../assets/newLasur/lefttop.png"
              alt=""
            />
          
          </div>
        </div>
      </div> -->
      <!-- <div class="section pageBox3">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBox3Middle">
  
          <div class="brandMemberBox">
            <el-carousel
              :interval="3000"
              arrow="always"
              height="48.39vh"
              autoplay
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(item, index) in brandMember"
                :key="index"
                :class="styleData[index]"
              >
                <div class="boxHeader">
                  <div class="boxTitle">
                    <span class="title1">{{ item.title1 }}</span>
                    <span class="title2"
                      >{{ item.title2 }} <img class="add" :src="item.add" alt=""
                    /></span>
                  </div>
                  <div class="titleImgBox">
                    <img class="tittleImg" :src="item.titleImg" alt="" />
                  </div>
                </div>

                <div class="mainContent3">
                  <img class="mainContentRight3" :src="item.itemImg" alt="" />
                  <div class="contentright3">
                    <div class="largeTitle">{{ item.largeTitle }}</div>
                    <div class="mainContentLeft3">
                      {{ item.introduce }}
                    </div>
                    <div class="line3"></div>
                    <img
                      class="seeMore3"
                      :src="item.seeMoreImg"
                      @click="enterBrand(item.id)"
                      alt=""
                    />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div> -->
      <div class="section pageBox4">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <!-- 底部 -->
          <div class="footerBox">
            <div class="footerBoxHeader">
              <div class="footerBoxHeaderLeft">
                <img class="codeImg" src="../assets/code.png" alt="" />
                <span class="codeText">兰树公众号</span>
              </div>
              <div class="footerBoxHeaderRight">
                <img class="codeImg" src="../assets/xcxNew.jpg" alt="" />
                <span class="codeText">兰树云小程序</span>
              </div>
            </div>
            <!-- <div class="footerLoginMain">
            <div class="footerLoginLeft">
             <div class="emailTitle">邮箱登录</div>
              <div class="loginMain">
                <div class="loginMainTop">
                  <div class="zhanghao">账号</div>
                  <input class="inputBox"  type="text"/>
                  <div class="emailEnd">@lasur.com</div>
                </div>
                <div class="loginMainBottom">
                  <div class="zhanghao">密码</div>
                  <input class="inputBoxNew"  type="password"/>
                  <div class="denglu">登录</div>
                </div>
              </div>
              <img style="width:1.25rem;" src="../assets/eamilImgOA.png" alt="">
              <div class="bottomOaTitle">兰树邮箱</div>
            </div>
            <div class="footerLoginRight">
              <div class="OATitle">兰树OA</div>
              <div class="loginMain">
                <div class="loginMainTop">
                  <div class="zhanghao">账号</div>
                  <input class="inputBoxOA"  type="text"/>
                </div>
                <div class="loginMainBottom">
                  <div class="zhanghao">密码</div>
                  <input class="inputBoxNew"  type="password"/>
                  <div class="denglu">登录</div>
                </div>
              </div>
              <img style="width:1.25rem;" src="../assets/OAImg.png" alt="">
              <div class="bottomOaTitle">兰树OA</div>
            </div>
        </div> -->
            <div class="footerMainBox">
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW"
                  >淮树旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s"
                  >心清堂官方企业店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0"
                  >水姻缘旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s"
                  >一清堂官方企业店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://drchung.tmall.com"
                  ><span>Dr.CHUNG</span>旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://zhibenqingfang.tmall.com"
                  >植本清方旗舰店</a
                >
              </li>
              <div class="lastHeader">
                <li><router-link to="/login" tag="a">登录</router-link></li>
                |
                <li><router-link to="/login" tag="a">注册</router-link></li>
              </div>
            </div>

            <div class="footerInfoBox">
              <div class="emailBox">邮箱: postermaster@lasur.com</div>
              <div class="phoneBox">电话: 0571-89025888</div>
              <div class="addressBox">
                地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼
              </div>
            </div>

            <div class="footerLine"></div>
            <div class="footerBoxBottom">
              <div class="footerLeft">
                Copyright © 2023 兰树化妆品股份有限公司
                <a
                  target="_blank"
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  >浙ICP备20018890号-1</a
                >
                | <img height="16px" src="../assets/plice.png" />&nbsp;<a
                  target="_blank"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740"
                  >浙公网安备 33052102000740号</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
// import {cpjs} from "../navigation/js/cpjs.js"

export default {
  data() {
    return {
      isVideo: false, // 是否显示视频
      screenWidth: document.body.clientWidth,
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true
      },
      brandMember: [
        {
          id: 1,
          introduce:
            "秉承“天然、安全、有效”的护肤理念，以先进技术凝萃,提取植物中蕴含的高活性精华，探索草本护肤能量，以新鲜植萃唤醒肌肤活力，为广大爱美人士提供天然亲肤的纯净美肌方案，尽享植萃呵护。",
          title1: "淮树",
          title2: "HUAISHU",
          titleImg: require("../assets/titleImg.png"),
          itemImg: require("../assets/item1.png"),
          seeMoreImg: require("../assets/Btn/huaishu.png"),
          largeTitle: "皮肤美丽顾问",
          add: require("../assets/add.png")
        },
        {
          id: 2,
          introduce:
            "秉持“中学为体、西学为用”的品牌发展理念，将西方科技融入东方智慧，以植物生命能量修护肌肤功能，用生物科技修护肌肤结构，用科技引领护肤新体验。",
          title1: "心清堂",
          title2: "XINQINGTANG",
          titleImg: require("../assets/titleImg2.png"),
          itemImg: require("../assets/item2.jpg"),
          seeMoreImg: require("../assets/Btn/xinBtn.png"),
          largeTitle: "科技护肤引领者",
          add: require("../assets/Xinadd.png")
        },
        {
          id: 3,
          introduce:
            '追求肌肤的“自然美、平衡美、活力美”，遵循"炮制虽繁必不敢省人工，品味虽贵必不敢减物力"的中药行原则，严苛选料、精研品质，专注问题性肌肤，从身、心、灵多方位修护肌肤。',
          title1: "一清堂",
          title2: "YIQINGTANG",
          titleImg: require("../assets/titleImg3.png"),
          itemImg: require("../assets/item3.jpg"),
          seeMoreImg: require("../assets/Btn/yiqingtang.png"),
          largeTitle: "专注问题性肌肤修复",
          add: require("../assets/Yiadd.png")
        },
        {
          id: 4,
          introduce:
            "因循东方美学的协调法则，“以水养肤，姻水结缘”，溯源水的至纯之美，以水能量沁润美肌，令肌肤回归至净本源，展现典雅的东方底蕴。",
          title1: "水姻缘",
          title2: "SHUIYINYUAN",
          titleImg: require("../assets/shui.png"),
          itemImg: require("../assets/item4.png"),
          seeMoreImg: require("../assets/Btn/huaishu.png"),
          largeTitle: "皮肤管理顾问",
          add: require("../assets/add.png")
        }
        // {
        // 	id:5,
        // 	introduce:'以蕴郁生机、自然草本、科学养肌为指导理念，将产品的安全性、温和性置于首位，严苛选材、倾心研制，旨为孕妈和婴童打造科学、放心的护肤产品。',
        // 	title1:'<span>Dr.CHUNG<span style="vertical-align: super;">+</span></span>',
        // 	title2:'Dr.CHUNG',
        // 	titleImg:require('../assets/titleImg5.png'),
        // 	itemImg:require('../assets/item5.png'),
        // 	seeMoreImg:require('../assets/Btn/zhongBtn.png'),
        // 	largeTitle:'孕婴童护肤引领者'
        // }
      ],
      styleData: ["first", "second", "third", "forth", "fifth"]
    };
  },
  created() {
    this.ipad();
    this.initVideo();
  },
  mounted() {
    // window.addEventListener('scroll', this.handlePageChange,true);
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };

    console.log("aaaa", this.currentpage);
  },

  methods: {
    scrollToTop() {
      fullpage_api.moveTo(1);
    },
    // 视频
    initVideo() {
      this.videoDetails = `<video
				 							  id="onemyVideo"
				 							  class="video-js vjs-big-play-centered vjs-fluid"
				 							  preload="auto"
											   muted
											  autoplay
											  loop
				 							  width="100%"
				 							  height="100%"
				 							  
				 							>
				 								<source
													type="application/x-mpegURL"
													src="https://www.lasur.com/media/beauty/video/2021/03/06/index.m3u8"
													>
				 							</video>`;
      //此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
      //页面dom元素渲染完毕，执行回调里面的方法
      //请求视频资源后关闭	 Banner
      // poster="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-07-07_10-24-11_17171.jpg"
      setTimeout(() => {
        this.isBanner = false;

        this.isVideo = true;
      }, 2000);
      this.$nextTick(() => {
        let myPlayer = this.$video(document.getElementById("onemyVideo"), {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: false,
          muted: true,
          //自动播放属性,muted:静音播放
          autoplay: true,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          loop: true,
          //设置视频播放器的显示宽度（以像素为单位）
          //  width: "100px",
          //设置视频播放器的显示高度（以像素为单位）
          //  height: "400px",
          controlBar: {
            playToggle: true
          }
        });
      });
    },
    ipad() {
      var os = (function() {
        var ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet =
            /(?:iPad|PlayBook)/.test(ua) ||
            (isAndroid && !/(?:Mobile)/.test(ua)) ||
            (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian && !isTablet;

        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc
        };
      })();
      if (os.isAndroid || os.isPhone) {
        // 手机
        // alert('手机端')
        this.$router.replace("/m");
        // document.write('<meta name="viewport" content="width=device-width,initial-scale=0.3">')
      } else if (os.isTablet) {
        // 平板
        // alert('平板端')
        this.$router.replace("/m");
        // document.write('<meta name="viewport" content="width=device-width,initial-scale=0.6">')
      } else if (os.isPc) {
        // alert('PC端')
        if (this.screenWidth <= 1024) {
          this.$router.replace("/m");
        } else {
        }
      }
    },
    // 		loadAnimate(){
    // 			$(function(){
    // 				$(window).on('scroll',function(){
    // 					if($(window).scrollTop()>= 500){
    // 						$('.mainContentRight').fadeIn(2000);
    // 					}
    // 				})
    // 			})
    // 		}

    // chooseBrand(opction){
    // 	this.$router({path:"/brand",query:{userId:opction}});
    // },
    chooseBrand(opction) {
      let that = this;
      this.brandActive = opction;
      console.log("opction", opction);
      // if(opction ==1){

      // }else if(opction ==2){

      // }else if(opction ==3){

      // }else if(opction ==4){

      // }else{

      // }
      // this.brandData.forEach(item =>{
      // 	if(item[opction-1].id == opction){
      // 		item[opction-1].chooseNumber = 1;
      // 	}else{
      // 		item[opction-1].chooseNumber =2;
      // 	}
      // })
    },

    enterProducts(id) {
      // 进入商品列表
      this.$router.push({ path: "/productsList", query: { userId: id } });
    },

    enterBrand(id) {
      console.log(id);
      if (id == 1) {
        this.$router.push({ path: "/huaiBrand" });
      } else if (id == 2) {
        this.$router.push({ path: "/brand" });
      } else if (id == 3) {
        this.$router.push({ path: "/yiBrand" });
      } else if (id == 4) {
        this.$router.push({ path: "/shuiBrand" });
      } else {
        this.$router.push({ path: "/zhongBrand" });
      }
    },
    enterAboutUs() {
      this.$router.push({ path: "/aboutlanshu" });
    }
  },
  watch: {
    /* 监听*/
    screenWidth(val) {
      this.screenWidth = val;
      console.log("this.screenWidth", this.screenWidth);
    }
  }
};
</script>

<style scoped>
.goTop {
  width: 2.6vw;
  height: 5.38vh;
  background: url(../assets/newLasur/goTop.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
  position: absolute;
  right: 3.8vw;
  bottom: 9.25vh;
  cursor: pointer;
  z-index: 999;
}
.goTop:hover {
  background: url(../assets/newLasur/goTop2.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}

.busiz-mengban {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  overflow: hidden;
}

.login-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-size: cover;
}

.homeContainer {
  margin: 0;
  padding: 0;
  position: relative;
}

.pageBoxOut2 {
  width: 90%;
  height: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
}

/* #app{
position: absolute;
top: 0;
bottom: 0;
left: 0;
width: 100%;
color:red;
} */

.pageBox2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

.pageBox3 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
}

.pageBox4 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  background-color: #f8f9fb;
  overflow: hidden;
}

.pageBox3Middle {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  /* margin-top: 6rem; */
  box-sizing: border-box;
  /* max-width: 1200px; */
}

.aboutUsBox {
  width: 11vw;
  position: absolute;
  top: -13.44vh;
  left: 4.48vw;
  display: flex;
  flex-direction: column;
  /* background: #000; */
  /* margin-top: 2em; */
}

.aboutUsBox span {
  font-size: 2.55vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #0839de;
  /* line-height: 64px;
		margin-left: 7%; */
}

.boxHeader {
  width: 70%;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  justify-content: space-between;
  box-sizing: border-box;
}

.boxTitle {
  display: flex;
  flex-direction: column;
  margin-left: 22%;
  box-sizing: border-box;
}

.title1 {
  font-size: 1.89vw;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #000000;
  line-height: 6.88vh;
}

.title2 {
  display: flex;
  align-items: center;
  font-size: 1.25vw;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #666666;
  line-height: 3.23vh;
}

.add {
  width: 0.83vw;
  margin-left: 1rem;
}

.introduce {
  font-size: 1.2vw;
  font-family: SourceHanSansCN-Normal;
  font-weight: normal;
  color: #000;
  /* line-height: 30px;
		margin-left: 7%; */
}

.mainContent {
  /* width:66%; */
  width: 75.73vw;
  height: 39.25vh;
  display: flex;
  flex-direction: row;
  background: #0839de;
  margin-top: 1%;
  border-radius: 7px;
  position: relative;
}

.contentLine {
  width: 0.26vw;
  height: 20vh;
  /* position: relative; */
  background: #80ff00;
  border-radius: 6px;
  position: absolute;
  left: 0;
  top: -13.44vh;
  -moz-transition: 1s;
  -webkit-transition: 1s;
  /* animation: aboutus3 3s;
	-webkit-animation: aboutus3 3s; */
}

.pageBox2.active .contentLine {
  left: 2.92vw;
  /* position: relative; */
}

/* 动画效果 */
@keyframes aboutus3 {
  from {
    opacity: 0;
    left: 0%;
  }
  to {
    opacity: 1;
    left: 6%;
  }
}

@-webkit-keyframes aboutus3 /* Safari 和 Chrome */ {
  from {
    opacity: 0;
    left: 0%;
  }
  to {
    opacity: 1;
    left: 6%;
  }
}

.mainContentLeftBox {
  /* width: 75.73vw;
	  height:260px; */
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  margin-left: 8%;
  margin-top: 5%;
  padding-bottom: 5%;
  box-sizing: border-box;
}

.mainContentLeft {
  /* width: 60%; */
  width: 47.6vw;
  height: 14.08vh;
  float: left;
  font-size: 0.99vw;
  /* font-family: PingFangSC-Regular, PingFang SC; */
  /* font-family: SourceHanSansCN-ExtraLight; */
  font-weight: 400;
  color: #fff;
  line-height: 3.52vh;
  box-sizing: border-box;
  letter-spacing: 0.03rem;
  text-indent: 0em;
  word-break: break-all;
}

/* 动画效果 */
@keyframes aboutus {
  from {
    opacity: 0;
    right: 0%;
    width: 0%;
  }
  to {
    opacity: 1;
    right: 14%;
    width: 13%;
  }
}

@-webkit-keyframes aboutus /* Safari 和 Chrome */ {
  from {
    opacity: 0;
    right: 0%;
    width: 0%;
  }
  to {
    opacity: 1;
    right: 14%;
    width: 13%;
  }
}

/* 初始状态 */
.mainContentRight {
  width: 0%;
  /* width:352px; */
  /* height: 240.5px; */
  position: absolute;
  right: 0%;
  top: 13%;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  /* animation: aboutus 3s;
	-webkit-animation: aboutus 3s; */
}

.pageBox2.active .mainContent .mainContentRight {
  /* width:352px; */
  /* height: 240.5px; */
  /* opacity: 1; */
  width: 18.28125vw;
  position: absolute;
  right: -4.48vw;
  top: -17vh;
  /* object-fit: cover; */
  /* transition: 0.2s; */
}

.leftBottom:hover {
  transform: scale(1.1);
}

.leftBottom {
  width: 0%;
  position: absolute;
  right: 0%;
  top: 16.13vh;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
}

.pageBox2.active .mainContent .leftBottom {
  /* width:352px; */
  /* height: 240.5px; */
  /* opacity: 1; */
  /* width: 313px;
	  height: 254px; */
  width: 24.48vw;
  /* height: 22%; */
  position: absolute;
  right: -2.24vw;
  top: 16.13vh;
}

.leftBottom img {
  width: 100%;
  height: 100%;
  /* object-fit: none; */
}

.seeMore {
  width: 12.08vw;
  height: 4.95vh;
  /* animation: aboutus2 2s;
	-webkit-animation: aboutus2 2s;	 */
  position: relative;
  top: 4.62vh;
  box-sizing: border-box;
  cursor: pointer;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  background: #fff;
  border-radius: 2.4vh;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.seeMore img {
  width: 1.77vw;
  height: 3.66vh;
  /* margin-left: 5px; */
  /* background: #000; */
}

.seeMore span {
  /* width: 7.91vw; */
  height: 4.95vh;
  font-size: 0.89vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #0839de;
  line-height: 4.95vh;
  text-align: left;
  text-indent: 1em;
  /* background: #000; */
}

.pageBox2.active .mainContent .seeMore {
  position: relative;
  top: 3rem;
  /* width: 20%; */
  box-sizing: border-box;
  cursor: pointer;
}

/* 动画效果 */
@keyframes aboutus2 {
  from {
    opacity: 0;
    top: 20%;
  }
  to {
    opacity: 1;
    top: 8%;
  }
}

@-webkit-keyframes aboutus2 {
  from {
    opacity: 0;
    top: 20%;
  }
  to {
    opacity: 1;
    top: 8%;
  }
}

.mainContent3 {
  width: 70%;
  display: flex;
  flex-direction: row;
  background: #1b5e5e;
  /* margin-left:22%; */
  margin: 0 auto;
  margin-top: 1rem;
  box-sizing: border-box;
}

.largeTitle {
  font-size: 1.25vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 6.88vh;
}

.contentright3 {
  width: 65%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-left: 22%;
  margin-top: 3%;
  padding-bottom: 5%;
  box-sizing: border-box;
}

.mainContentLeft3 {
  width: 110%;
  font-size: 0.9375vw;
  letter-spacing: 0.05rem;
  /* font-family: PingFangSC-Regular, PingFang SC; */
  font-weight: 400;
  color: #ffffff;
  line-height: 2.25vh;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: left;
}

.mainContentRight3 {
  width: 14%;
  display: flex;
  position: absolute;
  left: 10%;
  top: 0%;
}

.seeMore3 {
  width: 22%;
  box-sizing: border-box;
  margin-top: 6%;
  cursor: pointer;
}

.line3 {
  width: 100%;
  height: 2px;
  background-color: #dddddd;
  margin: 0 auto;
  opacity: 0.2;
  margin-top: 8%;
  box-sizing: border-box;
}

.tittleImg {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
}

/* footer */
.footerBox {
  width: 90%;
  /* height: 287px; */
  background: #f8f9fb;
  /* position:absolute;
 	bottom:0; */
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 999;
}

.footerBoxHeader {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
}

.footerBoxHeaderLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
}

.footerBoxHeaderRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5em;
}

.footerBoxHeaderMiddle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.codeImg {
  width: 100%;
}

.codeText {
  font-size: 0.88em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  /* margin-top: 0em; */
}

.footerLine {
  width: 79%;
  height: 1px;
  display: flex;
  background: #000000;
  opacity: 0.1;
  margin: 0 auto;
  align-items: center;
  margin-top: 1rem;
}

.footerInfoBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

.emailBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
}

.phoneBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-top: 0.5rem;
}

.addressBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-top: 0.5rem;
}

.footerBoxBottom {
  display: flex;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}

.footerLeft {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.footerLeft a {
  text-decoration: none;
  cursor: pointer;
  color: #666666;
}

.footerLeft a:hover {
  color: #003f98;
}

.footerMiddle {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerMiddle span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.footerRight {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerRight li a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}

.footerRight li {
  list-style: none;
}

.footerLast {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.lastHeader {
  display: flex;
  flex-direction: row;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  margin-left: 2em;
}

.lastHeader li a {
  text-decoration: none;
  font-size: 0.875rm;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 28px;
}

.lastHeader li {
  list-style: none;
}

.footerLast span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.footerMainBox {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 2em;
}

.footerShop {
  list-style: none;
  position: relative;
}

.footerShop span {
  margin-right: 10px;
}
.footerShop span::after {
  content: "+";
  display: block;
  position: absolute;
  top: -6px;
  right: 43px;
}

.footerShop a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  padding-left: 2em;
  line-height: 28px;
  cursor: pointer;
}

.pageBox1 {
  width: 100%;
  background-color: #000;
  /* background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-26-49_53459.jpeg) no-repeat;
	background-position:50% 50%;
	background-size: 100%; */
  /* overflow: hidden; */
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}

.brandMemberBox {
  width: 90%;
  /* position:absolute; */
  margin: 0 auto;
  flex-direction: row;
  justify-content: center;
  /* margin-top: 2em; */
  /* box-sizing: border-box; */
}

/* 导航 */
.navBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  position: absolute;
  justify-content: space-between;
  top: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 999;
}

.router-link-active {
  border-bottom: 3px solid #ffffff;
}

.navLogo {
  width: 10%;
  margin-left: 4em;
}

.navBarItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  /* margin-right: 5em; */
}

.navBarItem li {
  list-style: none;
  /*padding: 1.56em 2.5em 1.56em 2.5em;*/
  float: left;
  /* margin-left: 2em; */
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.navBarItem li a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 20px;
  padding-top: 1.3em;
  padding-bottom: 1.3em;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}

/* .elDropdown{
	margin-left: -6em;
	margin-top: -1em;
} */

.elDropdown a {
  color: #111111;
  text-decoration: none;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}

/* 轮播不同的样式设置 */
.first .mainContent3 {
  background-color: #0b4143 !important;
}

.second .titleImgBox {
  margin-top: 3.23vh;
  width: 20.8vw;
}

.second .boxTitle .title1 {
  font-family: PingFangSC-Medium, PingFang SC !important;
  color: #ff8300 !important;
  font-weight: bold;
}
.second .boxTitle .title2 {
  font-family: PingFangSC-Light, PingFang SC !important;
  color: #000 !important;
}

.second .add {
  width: 0.83vw;
}

.second .mainContent3 {
  background-color: #ff8300 !important;
}

.third .mainContent3 {
  background-color: #f7f8f8 !important;
}

.third .titleImgBox {
  margin-top: 3.23vh;
  width: 20.8vw;
}
.third .boxTitle .title1 {
  font-family: PingFangSC-Medium, PingFang SC !important;
  color: #3f3a60 !important;
}
.third .boxTitle .title2 {
  font-family: PingFangSC-Light, PingFang SC !important;
  color: #3f3a60 !important;
}

.third .line3 {
  width: 100%;
  height: 2px;
  background-color: #595757;
  margin: 0 auto;
  opacity: 0.2;
  margin-top: 8%;
  box-sizing: border-box;
}

.forth .mainContent3 {
  background-color: #1b5e5e !important;
}

.fifth .mainContent3 {
  background-color: #feafb9 !important;
}

.second .mainContentLeft3 {
  color: #fff !important;
  font-weight: 100 !important;
}

.third .mainContentLeft3 {
  color: #595757 !important;
}

.forth .mainContentLeft3 {
  color: #ffffff !important;
}

.fifth .mainContentLeft3 {
  color: #ffffff !important;
}

.second .largeTitle {
  color: #fff !important;
  font-weight: bold !important;
}

.third .largeTitle {
  color: #595757 !important;
}

.pageBoxMiddle {
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

/* 底部登录 */
.footerLoginMain {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 2%;
}

.footerLoginLeft {
  display: flex;
  width: 9.375rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  padding: 0.5rem 0 0.5rem 0;
  border-radius: 1.3125rem;
  background: #004399;
  cursor: pointer;
}

.emailTitle {
  width: 5%;
  writing-mode: tb-rl;
  letter-spacing: 0.3125rem;
  padding: 1.125rem;
  background: #bebebe;
  color: rgba(255, 255, 255, 0.8);
  border-radius: 10px 0px 0px 10px;
}

.OATitle {
  writing-mode: tb-rl;
  letter-spacing: 0.3125rem;
  padding: 1.125rem;
  background: #bebebe;
  color: rgba(255, 255, 255, 0.8);
  border-radius: 10px 0px 0px 10px;
}

.footerLoginRight {
  display: flex;
  width: 9.375rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  padding: 0.5rem 0 0.5rem 0;
  border-radius: 1.3125rem;
  background: #004399;
  margin-left: 3%;
  cursor: pointer;
}

.loginMain {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.loginMainTop {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.loginMainBottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0.625rem;
}

.inputBoxNew {
  width: 60%;
  margin-left: 0.3125rem;
  outline: none;
  line-height: 1.25rem;
}

.inputBox {
  width: 50%;
  margin-left: 0.3125rem;
  outline: none;
  line-height: 1.25rem;
}
.zhanghao {
  color: #222222;
  font-size: 0.875rem;
  margin-left: 0.625rem;
}

.emailEnd {
  color: #222222;
  font-size: 0.875rem;
  margin-left: 0.3125rem;
}

.denglu {
  font-size: 0.875rem;
  cursor: pointer;
  background: #004399;
  color: #ffffff;
  border-radius: 4px;
  padding: 0px 10px 0px 10px;
  line-height: 1.5625rem;
  margin-left: 0.625rem;
}

.inputBoxOA {
  width: 80%;
  margin-left: 0.3125rem;
  outline: none;
  line-height: 1.25rem;
}

.bottomOaTitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin-left: 0.3125rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue